<template>
    <div class="customer-management">


        <!-- 客户列表 -->
        <!-- <el-card class="main-content">
            <el-table ref="customerTable" :data="pagedCustomers" border stripe
                :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold' }" @row-click="handleRowClick"
                height="calc(100vh - 300px)">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" type="index" width="70" align="center"></el-table-column>
                <el-table-column prop="customerCode" label="客户编码" align="center"></el-table-column>
                <el-table-column prop="customerName" label="客户名称" width="100" align="center"></el-table-column>
                <el-table-column prop="customerPhone" label="联系电话" width="120" align="center"></el-table-column>
                <el-table-column prop="customerType" label="客户类型" align="center">
                    <template #default="scope">
                        {{ formatCustomerType(scope.row.customerType) }}
                    </template>
</el-table-column>
<el-table-column prop="organization" label="客户组织机构" align="center"></el-table-column>
<el-table-column prop="customerAddress" label="地址" align="center"></el-table-column>
<el-table-column prop="remark" label="备注" align="center"></el-table-column>

</el-table>
</el-card> -->
        <el-card>
            <div class="announcement-header">
                <div class="announcement-icon">
                    <i class="el-icon-location-outline"></i>
                </div>
                <div class="announcement-title">客户管理</div>
            </div>
            <div class="device-table-container">
                <div class="checkin-overview-list">
                    <div class="overview-header">
                        <div class="header-item">客户编码</div>
                        <div class="header-item">客户名称</div>
                        <div class="header-item">联系电话</div>
                        <div class="header-item">客户类型</div>

                        <div class="header-item">客户组织机构</div>
                        <div class="header-item">地址</div>
                        <div class="header-item">备注</div>
                    </div>
                    <!-- 滚动列表的视窗容器 -->
                    <div class="marquee-container">
                        <div class="overview-body">
                            <div class="overview-row" v-for="(item, index) in pagedCustomers" :key="index">
                                <div class="body-item">{{ item.customerCode }}</div>
                                <div class="body-item">{{ item.customerName }}</div>
                                <div class="body-item">{{ item.customerPhone }}</div>
                                <div class="body-item"> {{ formatCustomerType(item.customerType) }}</div>
                                <div class="body-item"> {{ item.alDay }}</div>

                                <div class="body-item"> {{ item.alNum }}{{ item.punit }}</div>


                            </div>
                            <div class="empty-tip" v-if="pagedCustomers.length === 0">
                                暂无数据
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>




    </div>
</template>

<script>
import { getCustomerList } from "@/api/customer";

export default {

    data() {
        return {
            // 搜索表单
            searchForm: {
                name: "",
                orderNo: "",
            },

            // 客户数据
            customers: [], // 原始数据
            filteredCustomers: [], // 筛选后的数据

            // 分页参数
            currentPage: 1,
            pageSize: 10,

            // 弹窗状态
            formVisible: false, // 新增/编辑弹窗
            detailVisible: false, // 详情弹窗
            isEditMode: false, // 是否为编辑模式

            // 表单数据
            customerForm: {
                id: "",
                customerCode: "",
                customerName: "",
                customerPhone: "",
                organization: "",
                customerAddress: "",
                remark: "",
                customerType: "",
                userId: "", // 关联用户ID
            },

            // 详情数据
            detailData: {},


        };
    },

    computed: {
        // 分页处理后的数据
        pagedCustomers() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredCustomers.slice(start, end);
        },
    },

    created() {
        this.initCustomerList();
    },

    methods: {
        // 1. 初始化客户列表（带userId）
        async initCustomerList() {
            try {
                const userId = localStorage.getItem("userId");
                if (!userId) {
                    this.$message.error("用户未登录，请重新登录");
                    return;
                }

                // 调用列表接口，传入userId
                const res = await getCustomerList({ userId });
                if (res.code === 200) {
                    this.customers = res.data || [];
                    this.filteredCustomers = [...this.customers]; // 初始化筛选数据
                } else {
                    this.$message.error(`获取数据失败：${res.message}`);
                }
            } catch (err) {
                console.error("获取客户列表异常：", err);
                this.$message.error("网络错误，获取数据失败");
            }
        },










        // 9. 格式化客户类型
        formatCustomerType(type) {
            const typeMap = {
                0: "网站注册",
                1: "线下推广",
                2: "客户推荐",
                social: "社交媒体",
                other: "其他渠道",
            };
            return typeMap[type] || type;
        },




    },
};
</script>

<style lang="scss" scoped>
.customer-management {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

/* 搜索区样式 */
.search-card {
    margin-bottom: 20px;

    .search-form {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        padding: 10px 0;
    }
}

/* 列表区样式 */
.main-content {
    margin-bottom: 15px;
}

/* 分页样式 */
.pagination-container {
    text-align: right;
    margin-top: 10px;
}

/* 详情弹窗样式 */
.detail-descriptions {
    margin-top: 10px;

    .el-descriptions-item__label {
        font-weight: 500;
        background-color: #f9fafb;
    }
}

/* 通用样式 */
.text-danger {
    color: #ff4d4f;
}

.form-container {
    padding: 10px 0;
}
</style>